import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'assembly/inventoryconversion';

const inventoryConversionService = {
  getItems: (data, signal) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
      signal,
    });
  },

  getItemById: (id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteItem: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },
};

export default inventoryConversionService;
